export type LoggedInInvestorHomeTarget = 'wait' | '/dashboard' | null;

/** Logo visits use this so a logged-in investor can open the marketing home. */
export const MARKETING_HOME_SEARCH = '?home=1';

export function isExplicitMarketingHome(search: string): boolean {
  const query = search.startsWith('?') ? search.slice(1) : search;
  return new URLSearchParams(query).get('home') === '1';
}

export function resolveLoggedInInvestorHomeRedirect(input: {
  authLoading: boolean;
  userLoading: boolean;
  firebaseUid: string | null;
  userType?: string | null;
  cachedUserType?: string | null;
  /** @deprecated Email verification no longer blocks app access. */
  emailVerified?: boolean;
  /** True when the visitor opened the home page on purpose (header logo). */
  explicitHome?: boolean;
}): LoggedInInvestorHomeTarget {
  if (input.explicitHome) return null;
  if (input.authLoading) return 'wait';
  if (!input.firebaseUid) return null;

  const type = input.userType || input.cachedUserType || null;
  if (!type) return input.userLoading ? 'wait' : null;
  if (type !== 'investor') return null;
  return '/dashboard';
}
